import { render } from "./approvalContents.vue?vue&type=template&id=8b6df1c4&scoped=true"
import script from "./approvalContents.vue?vue&type=script&lang=js"
export * from "./approvalContents.vue?vue&type=script&lang=js"

import "./approvalContents.vue?vue&type=style&index=0&id=8b6df1c4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b6df1c4"]])

export default __exports__